import { createFragment } from './create-fragment.js';
import { elementByKey } from './element-by-key.js';
export function createElementFactory(tagName, callback) {
    return ({ children, key, ...props }) => {
        const element = (key && elementByKey.get(key)) ?? document.createElement(tagName);
        if (key) {
            if (element.tagName !== tagName.toUpperCase()) {
                throw new Error(`cannot use key with tag: ${tagName}`);
            }
            elementByKey.set(key, element);
        }
        for (const attributeName of element.getAttributeNames()) {
            element.removeAttribute(attributeName);
        }
        for (const [propName, propValue] of Object.entries(props)) {
            switch (typeof propValue) {
                case `boolean`: {
                    if (propValue === true) {
                        element.setAttribute(propName, ``);
                    }
                    break;
                }
                case `number`:
                case `string`: {
                    element.setAttribute(propName, `${propValue}`);
                    break;
                }
                default: {
                    if (propValue != null) {
                        throw new TypeError(`cannot set attribute: ${propName}`);
                    }
                }
            }
        }
        callback(element, Array.from(createFragment({ children }).childNodes));
        return element;
    };
}
//# sourceMappingURL=create-element-factory.js.map